import { ref } from "vue";

export function useCheckResultDialogs() {
  const showTestamentDialog = ref(false);
  const showExistingCaseDialog = ref(false);
  const showStatementDialog = ref(false);
  const dialogCheckResults = ref(null);

  function openSequentialDialogs(checkResults) {
    dialogCheckResults.value = checkResults;
    if (checkResults.existingCase?.found) {
      showExistingCaseDialog.value = true;
    } else if (checkResults.testament?.found) {
      showTestamentDialog.value = true;
    }
  }

  function onExistingCaseDialogClosed() {
    showExistingCaseDialog.value = false;
    if (dialogCheckResults.value?.testament?.found) {
      showTestamentDialog.value = true;
    } else {
      dialogCheckResults.value = null;
    }
  }

  function onTestamentDialogClosed() {
    showTestamentDialog.value = false;
    dialogCheckResults.value = null;
  }

  function onStatementDialogClosed() {
    showStatementDialog.value = false;
    dialogCheckResults.value = null;
  }

  function openSingleDialog(type, result) {
    dialogCheckResults.value = { [type]: result };
    if (type === "testament") showTestamentDialog.value = true;
    else if (type === "statement") showStatementDialog.value = true;
    else showExistingCaseDialog.value = true;
  }

  return {
    showTestamentDialog,
    showExistingCaseDialog,
    showStatementDialog,
    dialogCheckResults,
    openSequentialDialogs,
    onTestamentDialogClosed,
    onExistingCaseDialogClosed,
    onStatementDialogClosed,
    openSingleDialog,
  };
}
